import React from 'react';
import { createRoot } from 'react-dom/client';
import './theme/index.css';
import App from './App';
import 'typeface-roboto';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  // strict mode disabled to prevent double useEffects
  // <React.StrictMode>
    <App />
  // </React.StrictMode>,
);
